import { Controller } from "@hotwired/stimulus"

// Auto-refreshes the dashboard page when sync is in progress
// Only refreshes if we're still on the dashboard page
export default class extends Controller {
  static values = {
    syncInProgress: Boolean
  }

  connect() {
    // Only set up refresh if we're on the dashboard page
    if (this.isSyncPage() && this.syncInProgressValue) {
      this.refreshInterval = setInterval(() => {
        // Double-check we're still on a sync page before refreshing
        if (this.isSyncPage()) {
          window.location.reload()
        } else {
          // If we navigated away, stop refreshing
          this.disconnect()
        }
      }, 5000) // 5 seconds
    }
  }

  disconnect() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
      this.refreshInterval = null
    }
  }

  isSyncPage() {
    // Check if current URL is a page with sync refresh
    const path = window.location.pathname
    return path === '/' || path === '/dashboard' || path.startsWith('/dashboard?') ||
           path === '/deals' || path.startsWith('/deals?')
  }
}

